module.exports = __webpack_public_path__ + "static/media/logo_bizon-prefab.7815787f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/logo_bizon-prefab.svg
// module id = 245
// module chunks = 0